"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SMTPSettingsTable = void 0;
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _react = _interopRequireWildcard(require("react"));
var _dmsbasereact = require("dmsbasereact");
var _sweetalert = _interopRequireDefault(require("sweetalert2"));
var _Permissions = require("dmsalertsystemreact/src/constants/Permissions");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const SMTPSettingsTable = () => {
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Server").d("Server"),
    column_name: "server",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Port").d("Port"),
    column_name: "port",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Email").d("Email"),
    column_name: "sender_email",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Password").d("Password"),
    column_name: "sender_password",
    filter: true
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    permissions: _Permissions.Permissions.CAN_EDIT_ALERT_SMTP_SETTINGS.name,
    column_name: "actions",
    sortable: false,
    can_edit: false,
    can_create: false,
    element: row => {
      return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Update").d("Update"),
        url: "/alert_smtp_settings/",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("Delete").d("Delete "),
        text: _reactIntlUniversal.default.get("DmsAlertTable.DeleteButtonMessage").d("The server will be deleted. Are you sure about it?"),
        url: "/alert_smtp_settings/",
        row_pk: row.pk
      }));
    }
  }];
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsTable, {
    header: header,
    managed: true,
    needs_authentication: true,
    ref: table,
    url: "/alert_smtp_settings/table",
    export_table: false,
    responsive: true
  });
};
exports.SMTPSettingsTable = SMTPSettingsTable;